import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Grid from '@zenbusiness/zui/Grid';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { superstyled } from '@zenbusiness/zui/styles';

const ButtonWrapper = superstyled({
  tag: Box,
  name: 'DownloadPage',
  slot: 'ButtonWrapper',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    '&:last-child': {
      marginTop: 16
    },
    [theme.breakpoints.up('md')]: {
      '&:last-child': {
        marginTop: 0
      }
    }
  })
});

const GridContainer = superstyled({
  tag: Grid,
  name: 'DownloadPage',
  slot: 'GridContainer',
  styles: ({ theme }) => ({
    columns: 2,
    gap: theme.spacing(0.5),
    [theme.breakpoints.up('sm')]: {
      gap: theme.spacing(4)
    }
  })
});

const AppButton = superstyled({
  tag: Button,
  name: 'DownloadPage',
  slot: 'AppButton',
  propsAdded: {
    fullWidth: true
  },
  styles: ({ theme }) => ({
    width: 135,
    borderRadius: 8,
    padding: '6px 9px',
    textTransform: 'none',

    [theme.breakpoints.up('sm')]: {
      height: 40
    }
  })
});

const QRCode = superstyled({
  tag: SharedAsset,
  name: 'DownloadPage',
  slot: 'QRCode',
  styles: ({ theme }) => ({
    width: 122,
    marginBottom: 16,
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  })
});

const AppleIcon = superstyled({
  tag: SharedAsset,
  name: 'DownloadPage',
  slot: 'AppleIcon',
  styles: {
    marginRight: 10
  }
});

const AppIconText = superstyled({
  tag: SharedAsset,
  name: 'DownloadPage',
  slot: 'AppIconText',
  styles: {
    width: '100%',
    height: 30
  }
});

const GooglePlayIcon = superstyled({
  tag: SharedAsset,
  name: 'DownloadPage',
  slot: 'GooglePlayIcon',
  styles: {
    marginRight: 5,
    width: 25,
    height: 25
  }
});

const config = {
  appleLogo: '/logo/Apple%20logo.svg',
  appleButtonText: '/icon/misc/download%20on%20the%20app%20store%20text.svg',
  appleStoreQR: '/picture/download-qr-code-app-store.png',
  googlePlayLogo: '/logo/google-play-logo.png',
  googlePlayButtonText: '/icon/misc/get it on google play text.svg',
  googlePlayQR: '/picture/download-qr-code-google-play.png'
};

const AppShareButtons = () => {
  const appleStoreRedirect = 'https://zenbusiness.onelink.me/NDnu/appstore';
  const googlePlayRedirect = 'https://play.google.com/store/apps/details?id=com.zenbusiness.app';

  return (
    <GridContainer>
      <ButtonWrapper>
        <QRCode alt="App Store QR code for Apple" src={config.appleStoreQR} />
        <AppButton
          clickstreamProps={{
            elementName: 'download_apple_store_redirect',
            elementText: 'Download on the App Store',
            destination: appleStoreRedirect
          }}
          href={appleStoreRedirect}
        >
          <AppleIcon alt="apple logo" src={config.appleLogo} />
          <AppIconText
            alt="Download on the App Store"
            src={config.appleButtonText}
          />
        </AppButton>
      </ButtonWrapper>

      <ButtonWrapper>
        <QRCode
          alt="Google Play QR code for Android"
          src={config.googlePlayQR}
        />
        <AppButton
          clickstreamProps={{
            elementName: 'download_google_play_redirect',
            elementText: 'Get it on Google Play',
            destination: googlePlayRedirect
          }}
          href={googlePlayRedirect}
        >
          <GooglePlayIcon alt="google play logo" src={config.googlePlayLogo} />
          <AppIconText
            alt="Get it on Google Play"
            src={config.googlePlayButtonText}
          />
        </AppButton>
      </ButtonWrapper>
    </GridContainer>
  );
};

export default AppShareButtons;
